/**
 * Utilities for handling multi-page table operations
 */

/**
 * Check if a table spans multiple pages
 * @param {Object} selectedTable - The selected table object
 * @returns {boolean} - True if the table spans multiple pages, false otherwise
 */
export const isMultiPageTable = (selectedTable) => {
  if (!selectedTable) return false;

  const pages = new Set();
  Object.keys(selectedTable).forEach((cellKey) => {
    if (cellKey.match(/^\d+_\d+$/)) {
      const cellLocationData = selectedTable[cellKey];
      if (cellLocationData && Array.isArray(cellLocationData)) {
        const firstCellInfo = cellLocationData[0];
        if (firstCellInfo && firstCellInfo.page) {
          pages.add(firstCellInfo.page);
        }
      }
    }
  });

  return pages.size > 1;
};

/**
 * Get all pages that a table spans
 * @param {Object} selectedTable - The selected table object
 * @returns {number[]} - Array of page numbers sorted in ascending order
 */
export const getTablePages = (selectedTable) => {
  if (!selectedTable) return [];

  const pages = new Set();
  Object.keys(selectedTable).forEach((cellKey) => {
    if (cellKey.match(/^\d+_\d+$/)) {
      const cellLocationData = selectedTable[cellKey];
      if (cellLocationData && Array.isArray(cellLocationData)) {
        const firstCellInfo = cellLocationData[0];
        if (firstCellInfo && firstCellInfo.page) {
          pages.add(firstCellInfo.page);
        }
      }
    }
  });

  return Array.from(pages).sort((a, b) => a - b);
};
